"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@mui/material/utils");
var Icon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M18.738 10.285C18.114 7.266 15.337 5 12 5 9.35 5 7.06 6.435 5.913 8.535 3.154 8.815 1 11.037 1 13.75 1 16.646 3.466 19 6.5 19h11.917C20.947 19 23 17.04 23 14.625c0-2.31-1.88-4.182-4.262-4.34zm-.321 6.965H6.5c-2.026 0-3.667-1.566-3.667-3.5s1.641-3.5 3.667-3.5 3.667 1.566 3.667 3.5H12c0-2.415-1.705-4.445-4.033-5.057A5.127 5.127 0 0 1 12 6.75c2.777 0 5.042 2.161 5.042 4.813V12h1.375c1.512 0 2.75 1.181 2.75 2.625s-1.238 2.625-2.75 2.625z" }))); };
var SvgWeather = (0, utils_1.createSvgIcon)(React.createElement(Icon, null), 'SvgWeather');
exports.default = SvgWeather;
